import { useEffect, useRef, useState } from "react";
import GolfThree from "../NewCustomerHeroSections/GolfThree";
import GolfTwo from "../NewCustomerHeroSections/GolfTwo";
import GolfOne from "../NewCustomerHeroSections/GolfOne";

export default function GolfCarousel() {
    const components = [
        <GolfOne key="one" />,
        <GolfTwo key="two" />,
        <GolfThree key="three" />,
    ];
    
    const [activeIndex, setActiveIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const [progress, setProgress] = useState(0);
    const [paused, setPaused] = useState(false);
    const elapsedRef = useRef(0);
    const isTransitioningRef = useRef(false);
    
    useEffect(() => {
        const duration = 60000;
        const intervalTime = 100;
        
        const progressInterval = setInterval(() => {
            if (paused || isTransitioningRef.current) return;
            
            elapsedRef.current += intervalTime;
            const nextProgress = Math.min((elapsedRef.current / duration) * 100, 100);
            setProgress(nextProgress);
            
            if (elapsedRef.current >= duration) {
                isTransitioningRef.current = true;
                setFade(false);
                
                setTimeout(() => {
                    setActiveIndex((prev) => (prev + 1) % components.length);
                    setFade(true);
                    elapsedRef.current = 0;
                    setProgress(0);
                    isTransitioningRef.current = false;
                }, 500);
            }
        }, intervalTime);
        
        return () => clearInterval(progressInterval);
    }, [paused, components.length]);
    
    return (
        <div className="h-full col-span-1 relative overflow-hidden">
            {/* Pause Toggle */}
            <div className="absolute top-3 right-3 z-10">
                <button
                    onClick={() => setPaused((prev) => !prev)}
                    className={`w-10 h-5 flex items-center rounded-full p-1 transition-all duration-300 cursor-pointer ${
                        paused ? 'bg-green-600' : 'bg-gray-400'
                    }`}
                >
                    <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-all duration-300 ${
                            paused ? 'translate-x-5' : 'translate-x-0'
                        }`}
                    />
                </button>
            </div>
            <div
                className={`h-full absolute inset-0 transition-opacity duration-500 ${
                    fade ? "opacity-100" : "opacity-0"
                }`}
            >
                {components[activeIndex]}
            </div>
            {/* Progress Bar */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gray-200/30">
                <div
                    className="h-full bg-green-600 transition-all duration-100"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
}
